// extracted by mini-css-extract-plugin
export default {"sobre":"Sobre_sobre__MS4Zo","item":"Sobre_item__4i59X","titulo":"Sobre_titulo__LJeAz"};